<template>
  <div>
    <section>
      <div class="container">
        <div class="text-center">
          <h2 class="font-size-medium font-weight-bold">Minhas Compras</h2>
          <p class="text-center">Veja o histórico das suas compras.</p>
        </div>
      </div>
    </section>

    <!-- TABS -->
    <section class="mt-4 mt-lg-5">
      <div class="container">
        <b-tabs
          content-class="mt-4 mt-lg-5"
          nav-class="default-tabs"
        >
          <!-- HISTORY -->
          <b-tab title="Histórico" active>
            <template
              v-if="loaderOrder && orders.length == 0"
            >
              <Loader
                color="color2"
                size="big"
              />
            </template>
            <template v-else>
              <div>
                <template
                  v-if="orders.length > 0"
                >
                  <div>
                    <div
                      class="mb-3 mb-lg-4"
                      v-for="order in orders"
                      :key="order.id"
                    >
                      <OrderCard
                        :order="order"
                        :expandable="true"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-4 mt-lg-5 text-center"
                    v-if="isLoadMoreOrdersVisible"
                  >
                    <Button
                      class="btn-outline-color2"
                      :loading="loaderOrder"
                      @click="loadMoreOrders"
                    >
                      Carregar mais
                    </Button>
                  </div>
                </template>
                <template v-else>
                  <p class="text-center">Você ainda não realizou uma compra</p>
                </template>
              </div>
            </template>
          </b-tab> <!-- HISTORY -->
          <!-- ITEMS -->
          <b-tab title="Livros comprados">
            <template
              v-if="loaderBooks && books.length == 0"
            >
              <Loader
                color="color2"
                size="big"
              />
            </template>
            <template v-else>
              <div>
                <template
                  v-if="books.length > 0"
                >
                  <BookThumbList
                    :books="books"
                  />
                </template>
                <template v-else>
                  <p class="text-center">Você ainda não realizou uma compra</p>
                </template>
              </div>
            </template>
          </b-tab> <!-- ITEMS -->
        </b-tabs>
      </div>
    </section> <!-- END TABS -->

  </div>
</template>

<script>

import OrdersService from '@/modules/orders/services/orders-service'

import BookThumbList from '@/components/books/BookThumbList'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import OrderCard from '@/components/orders/OrderCard'

export default {
  components: {
    BookThumbList,
    Button,
    Loader,
    OrderCard
  },
  metaInfo () {
    return {
      title: 'Minhas Compras',
      meta: [
        { vmid: 'og-title', name: 'og:title', content: 'Minhas Compras' }
      ]
    }
  },
  data () {
    return {
      orders: [],
      books: [],
      loaderBooks: false,
      loaderOrder: false,
      isLoadMoreOrdersVisible: true,
      isLoadMoreBooksVisible: true,
      booksPage: 1,
      ordersPage: 1
    }
  },
  created () {
    this.getOrders()
    this.getBooks()
  },
  methods: {
    async getOrders () {
      this.loaderOrder = true
      try {
        const orders = await OrdersService.getOrders({ page: this.ordersPage })
        this.orders = [...this.orders, ...orders]
        this.isLoadMoreOrdersVisible = orders.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderOrder = false
    },
    loadMoreOrders () {
      this.ordersPage++
      this.getOrders()
    },
    async getBooks () {
      this.loaderBooks = true
      try {
        const books = await OrdersService.getPurchasedItems('book')
        this.books = books
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderBooks = false
    }
  }
}
</script>
